import React from 'react'
import { Container } from 'reactstrap'
import {ProductForm} from '../components/Products/ProductForm'

const PostAnItem = () => {
  return (
    <Container>
        <ProductForm />
    </Container>
  )
}

export default PostAnItem